import Upload from "@/components/upload-comps/upload";

const DropzoneImgUploader = ({
  name,
  multiple,
  helperText,
  className,
  files,
  ...other
}) => {
  return (
    <Upload
      className={className}
      multiple
      accept={{ "image/*": [], "video/quicktime": [".mov"] }}
      files={files}
      isImageUploader={true}
      {...other}
    />
  );
};

export default DropzoneImgUploader;
